module.exports = __webpack_public_path__ + "img/bg.4f7a83ad.svg";